import { BookingOrigin } from "../constants";
import store from "../store";

export class Format {
  static toLowerFirst(value: string) {
    return value.charAt(0).toLowerCase() + value.slice(1);
  }

  static formatCurrency(value: string, digits: number = 2) {
    if (value != "0" && (value == "" || value == null || value == undefined))
      return "";
    const formated = this.formatNumber(value, digits);
    return Format.isCurrencySymbolBeforeAmount()
      ? store.state.settings.CurrencySymbol + formated
      : formated + store.state.settings.CurrencySymbol;
  }

  static isCurrencySymbolBeforeAmount() {
    let culture = store.state.settings.FormatCulture;
    if (culture === "" || culture === null || culture === undefined) {
      culture = "en-US";
    }
    const formatter = new Intl.NumberFormat(culture, {
      style: "currency",
      currency: "USD", // Moneda neutra solo para analizar el formato
      minimumFractionDigits: 2,
    });

    const parts = formatter.formatToParts(123);

    const currencyIndex = parts.findIndex((p) => p.type === "currency");
    const integerIndex = parts.findIndex((p) => p.type === "integer");

    return currencyIndex < integerIndex;
  }

  static formatNumber(value: string, digits: number = 2) {
    return this.formatNumberEx(value, 2, digits);
  }

  static formatNumberEx(
    value: string,
    minDigits: number = 0,
    maxDigits: number = 2,
    useGrouping: boolean = true
  ) {
    if (value != "0" && (value == "" || value == null || value == undefined))
      return "";
    let culture = store.state.settings.FormatCulture;
    if (culture === "" || culture === null || culture === undefined) {
      culture = "en-US";
    }
    const formatter = new Intl.NumberFormat(culture, {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits,
      useGrouping,
    });
    let s = formatter.format(Number(value));
    // remove trailing zeros
    const re = new RegExp(`[${this.getDecimalSeparator()}]0+$`);
    s = s.replace(re, "");
    return s;
  }

  static getDecimalSeparator(): string {
    let culture = store.state.settings.FormatCulture;
    if (culture === "" || culture === null || culture === undefined) {
      culture = "en-US";
    }
    const formatter = new Intl.NumberFormat(culture, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
    const s = formatter.format(1.1);
    const decimalSeparator = s.replace(/[\d]+/g, ""); // Remove digits
    return decimalSeparator;
  }

  static removeNonPrintableChars(value: string) {
    if (Format.IsNull(value)) {
      return value;
    }
    return value.replace(/[^\x00-\x7FÀ-ÿ]/g, "");
  }

  static highLightText(words: any, query: string) {
    const iQuery = new RegExp(query, "ig");
    return words.toString().replace(iQuery, function(matchedTxt) {
      return "<span class='post-creative-time'>" + matchedTxt + "</span>";
    });
  }

  static IsNull(value: any) {
    return value === "" || value === null || value === undefined;
  }

  static getOrigin() {
    const userAgent = navigator.userAgent;
    const isIpone = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      userAgent
    );
    const isAndroid = /Android.*wv/i.test(userAgent);

    if (isIpone) {
      return BookingOrigin.CZ_iOS;
    }
    if (isAndroid) {
      return BookingOrigin.CZ_Android;
    }
    return BookingOrigin.CZ_Web;
  }

  static toCamelCase(value: any) {
    if (value) {
      const words = value.split(" ");
      const camelCaseWords = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      return camelCaseWords.join(" "); // Join with spaces
    }
    return value;
  }

  static convertKeysToUpperCase(objArray) {
    return objArray.map((obj) => {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        const newKey = key.charAt(0).toUpperCase() + key.slice(1);
        newObj[newKey] = obj[key];
      });
      return newObj;
    });
  }

  static convertKeysToLowerCase(objArray) {
    return objArray.map((obj) => {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        const newKey = key.charAt(0).toLowerCase() + key.slice(1);
        newObj[newKey] = obj[key];
      });
      return newObj;
    });
  }

  static formatFullName(firstname: string, ...lastname: string[]) {
    return [firstname, ...lastname].join(" ").trim();
  }

  static decodeString(msg: string) {
    const strQuery = atob(msg);
    return decodeURIComponent(strQuery);
  }
}
